import getWireDistance from 'helpers/wires/getWireDistance'
import compressEntities from 'helpers/projects/compressEntities'
import sortItems from 'helpers/sortItems'
import deviceTypeName from 'helpers/accessControl/deviceTypeName'
import map from 'ramda/src/map'
import flatten from 'ramda/src/flatten'
import { ACCESS_PERIPHERAL_TYPES, ACCESS_TYPE_MAP } from 'helpers/globals'

export default state => {
  const mapDoorController = doorController => {
    const wire = Object.values(state.entities.wires.byId).find(w => w.start.id === doorController.id && w.start.type === 'doorController')
    const endDevice = wire && (wire.end.type === 'networkCloset' ? state.entities.networkClosets.byId[wire.end.id] : state.entities.doorControllers.byId[wire.end.id])
    const doorNames = doorController.doorIds.map(doorId => state.entities.doors.byId[doorId].name)

    return Object.assign({},
      doorController,
      {
        doorNames,
        modelName: doorController.model.text
      },
      doorController.isExpansion && {
        name: `${state.entities.doorControllers.byId[doorController.parentId].name}: ${doorController.name}`,
        modelConnection: doorController.model.connection
      },
      wire && {
        wireDistance: getWireDistance(wire.overlay, state.ui.isImperial, endDevice.dropLength).rawDistance.toFixed(),
        endDeviceName: endDevice.name
      },
      wire && doorController.isExpansion && {
        endDeviceType: wire.end.type === 'networkCloset' ? 'Network Closet' : 'Door Controller'
      }
    )
  }

  const mapPeripheral = (id, type) => {
    const peripheral = state.entities[type].byId[id]

    return {
      peripheralType: type === 'readers' ? `${peripheral.protocol} ${deviceTypeName(type)}` : deviceTypeName(type),
      type: (ACCESS_TYPE_MAP[type].length || ['auxiliaryInputs', 'auxiliaryOutputs'].includes(type)) ? peripheral.type : '—',
      wireType: `${peripheral.wireType} ${peripheral.wireShielded ? 'Shielded' : 'Unshielded'}`
    }
  }

  const mapDoor = door => {
    const wire = Object.values(state.entities.wires.byId).find(w => w.start.id === door.id && w.start.type === 'door')
    const doorController = state.entities.doorControllers.byId[door.controllerId]
    const doorControllerName = doorController.isExpansion ? `${state.entities.doorControllers.byId[doorController.parentId].name}: ${doorController.name}` : doorController.name

    return Object.assign({}, door, {
      name: `${doorControllerName}: ${door.name}`,
      wireDistance: getWireDistance(wire.overlay, state.ui.isImperial, doorController.dropLength).rawDistance.toFixed(),
      doorControllerName,
      peripherals: flatten(ACCESS_PERIPHERAL_TYPES.map(type => door[type].map(id => mapPeripheral(id, type))))
    })
  }

  const mapNetworkCloset = networkCloset => {
    const wires = Object.values(state.entities.wires.byId).filter(w => w.end.type === 'networkCloset' && w.end.id === networkCloset.id)

    const deviceNames = wires.map(wire => {
      if (wire.start.type === 'camera') {
        return { name: state.cameras.find(c => c.id === wire.start.id).name }
      }

      const device = state.entities[`${wire.start.type}s`].byId[wire.start.id]

      if (wire.start.type === 'doorController' && device.isExpansion) {
        return { name: `${state.entities.doorControllers.byId[device.parentId].name}: ${device.name}` }
      }

      return { name: device.name }
    })

    return {
      ...networkCloset,
      deviceNames: sortItems(deviceNames).map(device => device.name)
    }
  }

  const mapWiredDevice = wiredDevice => {
    const wire = Object.values(state.entities.wires.byId).find(w => w.start.id === wiredDevice.id && w.start.type === 'wiredDevice')
    const networkCloset = wire && state.entities.networkClosets.byId[wire.end.id]

    return Object.assign({},
      wiredDevice,
      wire && {
        wireDistance: getWireDistance(wire.overlay, state.ui.isImperial, networkCloset.dropLength).rawDistance.toFixed(),
        networkClosetName: networkCloset.name
      }
    )
  }

  const mapWire = wire => {
    const startDevice = wire.start.type === 'camera' ? state.cameras.find(c => c.id === wire.start.id) : state.entities[`${wire.start.type}s`].byId[wire.start.id]
    const endDevice = wire.end.type === 'networkCloset' ? state.entities.networkClosets.byId[wire.end.id] : state.entities.doorControllers.byId[wire.end.id]
    const endDeviceName = wire.end.type === 'doorController' && endDevice.isExpansion ? `${state.entities.doorControllers.byId[endDevice.parentId].name}: ${endDevice.name}` : endDevice.name

    return Object.assign({},
      wire,
      {
        endDeviceName,
        distance: getWireDistance(wire.overlay, state.ui.isImperial, endDevice.dropLength).rawDistance.toFixed()
      },
      startDevice && {
        startDeviceName: wire.start.type === 'doorController' && startDevice.isExpansion ? `${state.entities.doorControllers.byId[startDevice.parentId].name}: ${startDevice.name}` : startDevice.name
      }
    )
  }

  return compressEntities({
    doorControllers: {
      ...state.entities.doorControllers,
      byId: map(mapDoorController, state.entities.doorControllers.byId)
    },
    doors: {
      ...state.entities.doors,
      byId: map(mapDoor, state.entities.doors.byId)
    },
    networkClosets: {
      ...state.entities.networkClosets,
      byId: map(mapNetworkCloset, state.entities.networkClosets.byId)
    },
    wiredDevices: {
      ...state.entities.wiredDevices,
      byId: map(mapWiredDevice, state.entities.wiredDevices.byId)
    },
    wires: {
      ...state.entities.wires,
      byId: map(mapWire, state.entities.wires.byId)
    }
  })
}



// WEBPACK FOOTER //
// ./src/helpers/exports/compressEntitiesForExports.js